import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pencil, Trash2, X } from 'lucide-react';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import NProgress from "nprogress";
import 'nprogress/nprogress.css';

const Karyawan = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const NProgressSpinner = () => (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      <div
        style={{
          boxSizing: "border-box",
          display: "block",
          width: "40px",
          height: "40px",
          border: "4px solid #29d",
          borderRadius: "50%",
          borderTopColor: "transparent",
          animation: "spin 0.6s linear infinite",
          margin: "0 auto 10px"
        }}
      ></div>
      <div>Memuat data...</div>
    </div>
  );

  useEffect(() => {
    // Ambil data dari localStorage
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/login"); // Jika tidak ada user, arahkan ke login
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const [data, setData] = useState([]);

  const [pending, setPending] = useState(true);
  const [editData, setEdit] = useState(null);
  const [addData, setAdd] = useState(null); 
  const [formData, setFormData] = useState({ name: '', divisi: '' , type: '' });
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/vendors/karyawan`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data);
        setPending(false);
      });
  };

  const filteredData = data.filter((item) =>
  item.name.toLowerCase().includes(searchText.toLowerCase()) ||
  item.divisi.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleEdit = (vendor) => {
    setEdit(vendor);
    setFormData({ name: vendor.name, divisi: vendor.divisi, type: "karyawan" });
  };

  const handleAdd = (vendor) => {
    setAdd(vendor);
    setFormData({ name: vendor.name, divisi: vendor.divisi, type: "karyawan" });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/vendors/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Data berhasil dihapus.', 'success');
            fetchData();
          });
      }
    });
  };


  const handleUpdate = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_BASE_URL}api/vendors/${editData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then(() => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Data berhasil diperbarui!',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        setEdit(null);
        fetchData();
      });
  };

  const handleInsert = async (e) => {
  e.preventDefault();

  try {
    // 1. Ambil semua event dulu
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/vendors`);
    const json = await response.json();
    const existingEvents = json.data;

    // 2. Cek apakah nama sudah ada (case-insensitive)
    const isDuplicate = existingEvents.some(
      (vendor) => vendor.name.toLowerCase() === formData.name.toLowerCase()
    );

    if (isDuplicate) {
      // 3. Tampilkan error jika duplikat
      Swal.fire({
        icon: 'error',
        title: 'Gagal Menyimpan',
        text: 'Nama Karyawan sudah ada. Gunakan nama lain.',
      });
      return;
    }

    // 4. Lanjutkan menyimpan jika tidak duplikat
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/vendors/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!res.ok) {
      throw new Error('Gagal menyimpan data');
    }

    // 5. Berhasil
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Data berhasil disimpan!',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    setAdd(null);
    fetchData(); // refresh data tabel
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Terjadi kesalahan',
        text: error.message || 'Gagal menyimpan data',
      });
    }
  };


  const columns = [
    {
      name: 'Nama',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Divisi',
      selector: row => row.divisi,
      sortable: true,
    },
    {
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-yellow-400 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row)}
          >
            <Pencil size={16} />
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white p-1 rounded"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: '1px solid #ccc', // border luar tabel
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f3f4f6', // bg abu-abu muda
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
      },
    },
    headCells: {
      style: {
        borderRight: '1px solid #ccc',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #ccc',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #eee',
      },
    },
  };


  return (
    <div className="p-2">
      <div className="flex justify-between mb-4  gap-2">
        <button
            className="bg-black hover:bg-black/50 text-white px-4 py-2 rounded"
            onClick={handleAdd}>
            + Tambah 
          </button>  
          <input
            type="text"
            placeholder="Pencarian..."
            className="border border-gray-300 px-2 py-2 rounded w-full md:w-1/4"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
             
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        responsive
        progressPending={pending}
        progressComponent={<NProgressSpinner  />}
        highlightOnHover
        striped
        fixedHeader
        customStyles={customStyles}
      />

      {/* Modal Edit */}
      {editData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setEdit(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Edit Data Karyawan</h3>
            <form onSubmit={handleUpdate} className="space-y-4">
              <div>
                <label className="block font-medium">Nama</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  required
                />
                <h1 className="text-xs text-red-500 mb-4">Nama Lengkap sesuai dengan Nama di aplikasi Talenta, bukan nama panggilan saja.</h1>
              </div>
              <div>
                <label className="block font-medium">Divisi</label>
                <input
                  type="text"
                  value={formData.divisi}
                  onChange={(e) =>
                    setFormData({ ...formData, divisi: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setEdit(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70 "
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {addData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setAdd(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Tambah Karyawan</h3>
            <form onSubmit={handleInsert} className="space-y-4">
              <div>
                <label className="block font-medium">Nama</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  required
                />
                <h1 className="text-xs text-red-500 mb-4">Nama Lengkap sesuai dengan Nama di aplikasi Talenta, bukan nama panggilan saja.</h1>
              </div>
              <div>
                <label className="block font-medium">Divisi</label>
                <input
                  type="text"
                  value={formData.divisi}
                  onChange={(e) =>
                    setFormData({ ...formData, divisi: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setAdd(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Karyawan;
